import { useGetOrganizationSettingsQuery } from "~/shared/api/organization/organization.grpc";
import { useAuthSession } from "~/shared/hooks/auth.session.admin";

/**
 * Responsible zones are on for the current organization, by its own flag or an ancestor's.
 * An admin, or an admin inside another company (GetSetting knows only the caller's org), sees them; so does
 * everyone when the settings fail to load, since the backend checks the flag anyway.
 */
export function useZonesEnabled() {
  const { activeCompanyId, isAdmin } = useAuthSession();
  const { data, isError } = useGetOrganizationSettingsQuery({});
  // Another company's settings say nothing about this one; an unknown company reads its own.
  const otherCompany = !!data && !!activeCompanyId && String(data.id) !== String(activeCompanyId);
  return isAdmin || isError || otherCompany || !!data?.responsibleZoneEnabled;
}
